import { Anchor as MantineAnchor } from "@mantine/core";
import { polymorphicComponentWrapper } from "../../utilities";
import styles from "./anchor.module.scss";
import type { CustomAnchorFactory, IProps } from "./anchor.types";

const Anchor = polymorphicComponentWrapper<CustomAnchorFactory, IProps>("Anchor", ({ noWrap, ...props }, ref) => {
    return <MantineAnchor ref={ref} underline="always" classNames={{ root: styles["root"] }} {...props} />;
});

export { Anchor };
